import { AES } from 'crypto-ts'

export const encryptPassword = (password: string): string => {
  return AES.encrypt(password, 'ff276a4457e543b3db78f1c1462df89269b42c74eb7abe82').toString()
}
